import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { QnaheaderApi } from '../../../lib/repository/qnaheader/qnaheader.api';
import { IQnaheader } from '../../../lib/repository/qnaheader/qnaheader.model';

export const qnaheaderDetailChatResolver: ResolveFn<IQnaheader | null> = (
  route,
) => {
  const qnaheaderApi = inject(QnaheaderApi);

  const id = route.params['id'];

  if (!id || id === '-1') {
    return null;
  }

  return qnaheaderApi.findItem(id);
};
